// extracted by mini-css-extract-plugin
module.exports = {"qrwrapper":"_e571909","qrcode":"_f74ee02","qrbackground":"_88ea347"};